import { SidePanelType } from '@easy-lib/modules/shared/models/side-panel.model';
import { MessageTabs } from '@easy-lib/constants/message.constants';

export enum DesktopRoutes {
	EASY_FILTER_ROUTE = 'easy-filter',
	RECEIPT_ROUTE = 'receipt',
	RECEIPT_ROUTE_ERROR = 'receipt/error',
	NOTES_ROUTE = 'notes',
	MARKET_WATCH_ROUTE = 'market-watch'
}

export enum MobileRoutes {
	ORDERS_ROUTE = 'orders',
	PORTFOLIO_ROUTE = 'portfolio',
	PORTFOLIO_SOLD_ITEMS = 'portfolio-sold-items',
	MARKET_WATCH_ROUTE = 'market-watch',
	AI_MARKET_ASSISTANT = 'ai-market-assistant',
	SEARCH_ROUTE = 'search',
	MENU_ROUTE = 'menu',
	RECEIPT_ROUTE = 'money-receipt',
	RECEIPT_ROUTE_ERROR = 'money-receipt/error',
	SETTING_ROUTE = 'setting',
	NOTES_ROUTE = 'note-management',
	STOCK_DETAILS_MESSAGES_ROUTE = 'messages',
	CHANGE_HISTORY = 'release-notes'
}
export enum SharedRoutes {
	MAIN_ROUTE = '',
	BANK_ACCOUNT_ROUTE = 'payment/bank-account',
	MARKET_MAP_ROUTE = 'market-map',
	STOCK_DETAILS_ROUTE = 'stock-details',
	STOCK_DETAILS_CONDITION_ROUTE = 'condition',
	ORDER_HISTORY_ROUTE = 'orders-history',
	OPTION_ROUTE = 'option',
	ALGO_HISTORY_ROUTE = 'algo-orders-history',
	EASY_CHART_ROUTE = 'easy-chart',
	PAYMENT_ROUTE = 'payment',
	CONDITION_ROUTE = 'conditional',
	TARANSACTIONS_ROUTE = 'transactions',
	ACCOUNT_ACTIVITY_ROUTE = 'account-activity',
	MENU_ROUTE = 'menu',
	MESSAGES_ROUTE = 'messages',
	IMMEDIATE_MESSAGE_ROUTE = 'immediate-messages',
	PORTFOLIO_MESSAGE_ROUTE = 'portfolio-messages',
	MOFID_MESSAGE_ROUTE = 'mofid-messages',
	WALLET_CARD_ROUTE = 'wallet-card',
	AGREEMENT_ROUTE = 'agreement',
	FUND_ROUTE = 'funds',
	SUPPORT_ROUTE = 'support',
	SETTING = 'setting',
	BROKER_CHANGE_ROUTE = 'broker-change',
	MARKET_VIEW_ROUTE = 'market-view',
	CHILDREN_ROUTE = 'children'
}
export const RequiredMarketDepthPopUpDesktopRout: string[] = [
	SharedRoutes.ORDER_HISTORY_ROUTE,
	SharedRoutes.ALGO_HISTORY_ROUTE,
	SharedRoutes.OPTION_ROUTE,
	SharedRoutes.TARANSACTIONS_ROUTE,
	DesktopRoutes.EASY_FILTER_ROUTE,
	// SharedRoutes.EASY_CHART_ROUTE,
	SharedRoutes.MARKET_MAP_ROUTE
];

export enum RouteTitles {
	TARANSACTIONS_ROUTE = 'تاریخچه تراکنش',
	ORDER_HISTORY_ROUTE = 'تاریخچه سفارشات',
	EASY_FILTER_ROUTE = 'ایزی فیلتر',
	EASY_CHART_ROUTE = 'چارت',
	MARKET_MAP_ROUTE = 'نقشه بازار'
}

export function urlToComponentDesktop(url, value?: any) {
	switch (url) {
		case SharedRoutes.IMMEDIATE_MESSAGE_ROUTE:
			return { sidePanel: SidePanelType.Messages, data: { selectedTab: MessageTabs.Immediate } };
		case SharedRoutes.PORTFOLIO_MESSAGE_ROUTE:
			return { sidePanel: SidePanelType.Messages, data: { selectedTab: MessageTabs.Portfolio } };
		case SharedRoutes.MOFID_MESSAGE_ROUTE:
			return { sidePanel: SidePanelType.Messages, data: { selectedTab: MessageTabs.Mofid } };
		case SharedRoutes.MESSAGES_ROUTE:
			return { sidePanel: SidePanelType.Messages, data: { selectedTab: MessageTabs.Broker } };
		case SharedRoutes.AGREEMENT_ROUTE:
			return { sidePanel: SidePanelType.Agreement };
		case SharedRoutes.ACCOUNT_ACTIVITY_ROUTE:
			return { sidePanel: SidePanelType.AccountActivity };
		case SharedRoutes.CONDITION_ROUTE:
			return { sidePanel: SidePanelType.Conditional, value };
		case SharedRoutes.EASY_CHART_ROUTE:
			return { sidePanel: SidePanelType.EasyChart };
		default:
	}
}
